import moment from "moment";
import CryptoJS from "crypto-js";
import { buyerCustomerDocsContractTypes, listingContractTypes, otherDocsContractTypes } from "../commondata/commonData";
import { message } from "antd";

/* -----------function to format a 10 digit phone no in the US format ---------------- */
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return "";
  }
  let cleanedPhoneNo = phoneNumber.toString().replace(/\D/g, "");
  let formattedNumber = "";
  if (cleanedPhoneNo.length > 10) {
    cleanedPhoneNo = cleanedPhoneNo.substr(0, 10);
  }
  for (let i = 0; i < cleanedPhoneNo.length; i++) {
    if (i === 0) {
      formattedNumber += `(${cleanedPhoneNo[i]}`;
    } else if (i === 3) {
      formattedNumber += `) ${cleanedPhoneNo[i]}`;
    } else if (i === 6) {
      formattedNumber += ` - ${cleanedPhoneNo[i]}`;
    } else {
      formattedNumber += cleanedPhoneNo[i];
    }
  }
  return formattedNumber;
};

function isMobileApp() {
  return /(android|iphone|ipad|ipod)/i.test(navigator.userAgent) && /app/i.test(navigator.userAgent);
}
// Checking if the user is on a mobile device
const isMobileDevice = /Mobi|Android|iPhone|iPod|iPad|Windows Phone/i.test(navigator.userAgent);
// to get the more Accuracy
export function detectMobile() {
  return isMobileApp() || isMobileDevice;
}

export function detectWebView() { // returns true on mobile app
  return window?.ReactNativeWebView != null;
}

export const truncateStr = (string, n) => {
  if (!string) return "";
  if (string.length <= n) return string;
  const truncated = string.substr(0, n - 3);
  return `${truncated}...`;
};

export const convertTimeInto24HourFormat = (time, source) => {
  if (time && time !== "undefined") {
    const match = time.toString().match(/^(\d{1,2})(:)([0-5]\d)(:[0-5]\d)?\s?([APap][Mm])?$/);
    if (match) {
      let hours = parseInt(match[1]);
      const minutes = parseInt(match[3]);
      const isPM = /p/i.test(match[5]);

      if (isPM && hours < 12) {
        hours += 12;
      } else if (!isPM && hours === 12) {
        hours = 0;
      }
      // Converting to 24-hour format and format the result
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    }
  }
  return (source = "OFFER_TABLE" ? "N/A" : "");
};

export const formatStateValue = (inputValue) => {
  if (inputValue) {
    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "").toUpperCase();
    return cleanedValue.slice(0, 2);
  }
  return "";
};

export const formatAndParse = (value) => {
  if (!value) {
    return 0;
  }
  return parseFloat(value?.toString()?.replace(/[^0-9.]/g, "")) || 0;
};

export const getValuesFromCookies = async (cookieName) => {
  const cookies = document.cookie?.split("; ");
  for (const cookie of cookies) {
    const [name, value] = cookie.split("=");
    if (name.trim() === cookieName) {
      return value.trim();
    }
  }

  return null;
};

export const generateInitials = (fullName = "") => {
  const init = fullName?.trim().split(" ");
  const initials = init ? init[0]?.[0]?.toUpperCase() + init[init.length - 1]?.[0]?.toUpperCase() : "";
  return initials;
};

export const filterEmptyAndUndefinedKeys = (data) => {
  if (!data || typeof data !== "object") {
    return {};
  }
  return Object.fromEntries(Object.entries(data).filter(([key, value]) => key !== undefined && key.trim() !== ""));
};
export const filterEmptyAndUndefinedValues = (data) => {
  try {
    if (!data || typeof data !== "object" || Array.isArray(data)) {
      return {};
    }

    return Object.fromEntries(
      Object.entries(data).filter(([key, value]) => {
        if (!value || (typeof value === "string" && value.trim() === "")) {
          return false;
        }
        if (Array.isArray(value) && value.length === 0) {
          return false;
        }
        if (typeof value === "object" && Object.keys(value).length === 0) {
          return false;
        }
        // Keeping everything else
        return true;
      })
    );
  } catch (error) {
    return {};
  }
};
export const formatDate = (date) => {
  if (!date || !moment(date).isValid()) {
    return "";
  }
  return moment(date).format("MM-DD-YYYY");
};

export const generateInitialsFromObj = (item) => {
  const { fullName, firstName, lastName } = item || {};
  if (!fullName && !firstName && !lastName) return "";

  let firstInitial = "";
  let lastInitial = "";

  if (fullName) {
    const init = fullName.trim().split(" ");
    firstInitial = init[0]?.[0]?.toUpperCase() || "";
    lastInitial = init.length > 1 ? init[init.length - 1]?.[0]?.toUpperCase() : "";
  } else {
    if (firstName) {
      firstInitial = firstName.trim()[0]?.toUpperCase() || "";
    }
    if (lastName) {
      lastInitial = lastName.trim()[0]?.toUpperCase() || "";
    }
  }

  return firstInitial + lastInitial;
};

export const capitalizeStr = (str) => {
  if (typeof str !== "string" || !str.length) {
    return "";
  }
  return str[0].toUpperCase() + (str.length > 1 ? str.substring(1).toLowerCase() : "");
};

export const generateFullNameFromObj = (item) => {
  const { fullName, firstName, middleName, lastName } = item || {};
  if (typeof fullName === "string" && fullName.trim()) {
    return fullName.trim();
  }

  const capitalizedFirstName = capitalizeStr(firstName);
  const capitalizedMiddleName = middleName && middleName !== "null" ? capitalizeStr(middleName) : "";
  const capitalizedLastName = capitalizeStr(lastName);

  const formattedFullName = [capitalizedFirstName, capitalizedMiddleName, capitalizedLastName].filter(Boolean).join(" ");
  return formattedFullName;
};

export const handleShowPicker = (event) => {
  try {
    event?.target?.showPicker();
  } catch (error) {
    console.log("Error occurred while showing the date or time picker");
  }
};

export const getCoAgentsIds = (coAgentData) => {
  let coAgentsIds = [];
  if (Array.isArray(coAgentData) && coAgentData.length) {
    coAgentData.forEach((el) => {
      coAgentsIds.push(el._id);
    });
  }
  return coAgentsIds;
};
// export const getMonthDifference = ({startMonth, startYear, endMonth, endYear}) => {
//   console.log(startMonth, startYear, endMonth, endYear);
//   const totalMonths = (endYear - startYear) * 12 + (endMonth - startMonth) + 1;
//   const months = [];
//   for (let i = 0; i < totalMonths; i++) {
//     const month = ((startMonth + i - 1) % 12) + 1;
//     const year = startYear + Math.floor((startMonth + i - 1) / 12);
//     months.push({ month, year });
//   }
//   return months;
// }

const mapSigners = (coClient, role) =>
  coClient.signers?.map((signer) => ({
    ...signer,
    corpKey: coClient.key,
    openFor: role,
    isCorp: true,
  })) || [];

export const mapClientsForSendEmail = ({ clients, role, agents }) => {
  const mergedClients = [...(clients ? clients : []), ...(agents ? agents : [])];
  return (
    mergedClients.map((coClient) => ({
      ...coClient,
      openFor: coClient.isAgent ? coClient.openFor : role,
      isReadOnly: false,
      isAddedByUser: false,
      ...(coClient.isCorp
        ? {
            signers: mapSigners(coClient, role),
            isCorp: true,
          }
        : { isCorp: false }),
    })) || []
  );
};

// Helper function to merge signers for corp clients
const mergeSigners = (existingSigners = [], newSigners = []) => {
  const seenSignerIds = new Set(existingSigners.map((signer) => signer.personId?._id || signer.key));
  return [
    ...existingSigners,
    ...newSigners.filter((newSigner) => {
      const signerId = newSigner.personId?._id || newSigner.key;
      return !seenSignerIds.has(signerId);
    }),
  ];
};

const processClients = (clientIds = [], corpMap, individualMap) => {
  clientIds.forEach((client = {}) => {
    const { isCorp, key, personId, signers = [] } = client;
    if (isCorp) {
      if (!corpMap.has(key)) {
        corpMap.set(key, { ...client, signers: signers || [] });
      } else {
        const existingCorpClient = corpMap.get(key);
        const mergedSigners = mergeSigners(existingCorpClient.signers, signers);
        corpMap.set(key, { ...existingCorpClient, signers: mergedSigners });
      }
    } else {
      const personIdValue = personId?._id || key;
      if (!individualMap.has(personIdValue)) {
        individualMap.set(personIdValue, { ...client, signers: signers || [] });
      }
    }
  });
};
const processAgents = ({ agents, individualMap, currentAgentId }) => {
  if(!Array.isArray(agents)) return individualMap
  agents.forEach((agent) => {
    if (!agent) return;
    const { key, personId } = agent;
    if (!personId && !key) return;
    const currentAgentIdStr = String(currentAgentId || "");
    const personIdStr = String(personId || "");

    if ((personIdStr.length === 24 || currentAgentIdStr.length === 24) && personIdStr === currentAgentIdStr) {
      return;
    }
    const personIdValue = personIdStr.length === 24 ? personIdStr : key || "";
    if (!personIdValue) return;

    if (!individualMap.has(personIdValue)) {
      individualMap.set(personIdValue, {  ...agent,  personId: personIdStr.length === 24 ? personIdStr : null, _id: personIdValue});
    }
  });
};

const processAgentIds = ({ agents, individualMap, currentAgentId }) => {
  if(!Array.isArray(agents)) return individualMap
  agents.forEach((agent) => {
    if (!agent) return;
    const {_id } = agent;
    if (!_id) return;
    const currentAgentIdStr = String(currentAgentId || "");
    const personIdStr = String(_id || "");

    if ((personIdStr.length === 24 || currentAgentIdStr.length === 24) && personIdStr === currentAgentIdStr) {
      return;
    }
    if (!individualMap.has(personIdStr)) {
      individualMap.set(personIdStr, {  ...agent,  personId: personIdStr.length === 24 ? personIdStr : null, _id: personIdStr});
    }
  });
};


export const getcombinedClientsAndAgents = ({ allContractDocuments = [], condition, isClientDoc = false, currentAgentId, contractType }) => {
  try {
    const corpSellers = new Map();
    const individualSellers = new Map();
    const corpBuyers = new Map();
    const individualBuyers = new Map();
    const allSameSideAgents = new Map();
    allContractDocuments?.forEach((document = {}) => {
      if (condition === "SELLER" || !condition) {
        processClients(document?.sellerIds, corpSellers, individualSellers);
      }
      if (isClientDoc) {
        const agentIdsKey = buyerCustomerDocsContractTypes.includes(document?.contractType) ? "buyerAgentIds" : "sellerAgentIds";
        processAgentIds({ agents: document?.[agentIdsKey], individualMap: allSameSideAgents, currentAgentId });
      }
      if (condition === "BUYER" || !condition) {
        processClients(document?.buyerIds, corpBuyers, individualBuyers);
      }
    });
    let combinedSellerIds = condition === "BUYER" ? [] : [...corpSellers.values(), ...individualSellers.values()];
    let combinedBuyerIds = condition === "SELLER" ? [] : [...corpBuyers.values(), ...individualBuyers.values()];
   
    if ([...otherDocsContractTypes,"WY_RLC"].includes(contractType) && currentAgentId) {
      combinedBuyerIds = combinedBuyerIds.filter((el) => {
        if (el.isCorp) {
          return !el.signers?.some((signer) => signer?.personId?._id === currentAgentId);
        } else {
          return el?.personId?._id !== currentAgentId;
        }
      });
      combinedSellerIds = combinedSellerIds.filter((el) => {
        if (el.isCorp) {
          return !el.signers?.some((signer) => signer?.personId?._id === currentAgentId);
        } else {
          return el?.personId?._id !== currentAgentId;
        }
      });
    }
    return {
      combinedSellerIds,
      combinedBuyerIds,
      combinedSameSideAgents: [...allSameSideAgents.values()],
    };
  } catch (error) {
    return {
      combinedSellerIds: [],
      combinedBuyerIds: [],
      combinedSameSideAgents: [],
    };
  }
};

export const removePersonObject = (corporateClients = []) => {
  for (let i = 0; i < corporateClients?.length; i++) {
    if (corporateClients?.[i]?.isCorp) {
      for (let j = 0; j < corporateClients?.[i]?.signers?.length; j++) {
        corporateClients[i].signers[j].personId = corporateClients?.[i]?.signers[j]?.personId?._id || corporateClients?.[i]?.signers[j]?.personId;
      }
    } else {
      corporateClients[i].personId = corporateClients?.[i]?.personId?._id || corporateClients?.[i]?.personId;
    }
  }
  return corporateClients || [];
};

export const validateEmail = (email) => {
  if (!email) {
    return false;
  }
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Matching Ant Design's behavior
  return pattern.test(email);
};


export const encryptUrlParams = (params) => {
  try {
    if (!params) return "";
    const encryptedParams = CryptoJS.AES.encrypt(JSON.stringify(params), "url resure encryption").toString();
    return encodeURIComponent(encryptedParams);
  } catch (error) {
    console.error("Error encrypting URL parameters:", error);
    return "";
  }
};

export const decryptUrlParams = (encryptedParams) => {
  try {
    if (!encryptedParams) return null;
    let decodedParams = decodeURIComponent(encryptedParams);
    if (/%[0-9A-Fa-f]{2}/.test(decodedParams)) {
      decodedParams = decodeURIComponent(decodedParams);
    }
    const decryptedBytes = CryptoJS.AES.decrypt(decodedParams, "url resure encryption");
    const decryptedParams = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedParams);
  } catch (error) {
    console.error("Error decrypting URL parameters:", error);
    return null;
  }
};

export const parseValue = (value) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};
export const formatArrayContents = (values = []) => {
  try {
    parseValue(values);
    return Array.isArray(values) ? values.join(", ") : values ? values : "N/A";
  } catch (error) {
    return "N/A";
  }
};

export const getStreetAddress = (fullAddress) => {
  try {
    if (!fullAddress || typeof fullAddress !== "string") {
      return "";
    }
    const addressParts = fullAddress.split(",").map((part) => part?.trim());
    const streetAddressParts = addressParts.slice(0, -2);
    return streetAddressParts.join(", ");
  } catch (error) {
    return "";
  }
};
// formatting the property address 
export const buildPropertyFullAddress = (payloadObj) => {
  if (typeof payloadObj !== "object") return "";

  let safeTrimmedObj = {};
  const addressKeys = ["StreetNumber", "DirPrefix", "StreetName", "StreetSuffix", "DirSuffix", "UnitLabel", "UnitNumber", "City", "State", "ZipCode"];
  for (const key of addressKeys) {
    const value = payloadObj[key];
    safeTrimmedObj[key] = value ? String(value).trim() : "";
  }

  return `${safeTrimmedObj.StreetNumber}${safeTrimmedObj.DirPrefix ? ` ${safeTrimmedObj.DirPrefix}` : ""}${safeTrimmedObj.StreetName ? ` ${safeTrimmedObj.StreetName}` : ""}${safeTrimmedObj.StreetSuffix ? ` ${safeTrimmedObj.StreetSuffix}` : ""}${safeTrimmedObj.DirSuffix ? ` ${safeTrimmedObj.DirSuffix}` : ""}${safeTrimmedObj.UnitLabel && safeTrimmedObj.UnitNumber ? `, ${safeTrimmedObj.UnitLabel} ${safeTrimmedObj.UnitNumber}` : !safeTrimmedObj.UnitLabel && safeTrimmedObj.UnitNumber ? `, ${safeTrimmedObj.UnitNumber}` : ""}${safeTrimmedObj.City ? `, ${safeTrimmedObj.City}` : ""}${safeTrimmedObj.State ? `, ${safeTrimmedObj.State}` : ""}${safeTrimmedObj.ZipCode ? ` ${safeTrimmedObj.ZipCode}` : ""}`.trim();
};

// formatting the property Street address 
export const buildPropertyStreetAddress = (payloadObj) => {
  if (typeof payloadObj !== "object") return "";

  let safeTrimmedObj = {};
  const addressKeys = ["StreetNumber", "DirPrefix", "StreetName", "StreetSuffix", "DirSuffix", "UnitLabel", "UnitNumber"];
  for (const key of addressKeys) {
    const value = payloadObj[key];
    safeTrimmedObj[key] = value ? String(value).trim() : "";
  }

  return `${safeTrimmedObj.StreetNumber}${safeTrimmedObj.DirPrefix ? ` ${safeTrimmedObj.DirPrefix}` : ""}${safeTrimmedObj.StreetName ? ` ${safeTrimmedObj.StreetName}` : ""}${safeTrimmedObj.StreetSuffix ? ` ${safeTrimmedObj.StreetSuffix}` : ""}${safeTrimmedObj.DirSuffix ? ` ${safeTrimmedObj.DirSuffix}` : ""}${safeTrimmedObj.UnitLabel && safeTrimmedObj.UnitNumber ? `, ${safeTrimmedObj.UnitLabel} ${safeTrimmedObj.UnitNumber}` : !safeTrimmedObj.UnitLabel && safeTrimmedObj.UnitNumber ? `, ${safeTrimmedObj.UnitNumber}` : ""}`.trim();
};

export const buildQueryString = (params) => {
  if (!typeof params === "object") return "";
  return Object.keys(params)
    .filter((key) => params[key] !== null && params[key] !== undefined && params[key] !== "")
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join("&");
};

export const getCategoryDataHandle = ({ rootDocData }) => {
  if (rootDocData) {
    let { openFor, offerId, contractType, propertyId, documentId, ertsId } = rootDocData || {};
    let category, categoryId, status;
    if (openFor === "BUYER_AGENT") {
      category = "BUYER";
      categoryId = offerId;
    } else {
      category = "SELLER";
      categoryId = listingContractTypes.includes(contractType) ? documentId : ertsId ? ertsId : propertyId ? propertyId : null;
    }

    return { category, categoryId, status };
  } else {
    return { category: null, categoryId: null, status: null };
  }
};

export const decryptQuery = (response) => {
  try {
    if (!response || response.trim() === "") {
      return null;
    }
    let encryptedData;
    try {
      encryptedData = response.startsWith('"') && response.endsWith('"') ? JSON.parse(response) : response;
    } catch (parseError) {
      encryptedData = response;
    }
    let bytes = CryptoJS.AES.decrypt(encryptedData, "url resure encryption");
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    if (!decryptedData) {
      return null;
    }
    try {
      return JSON.parse(decryptedData);
    } catch (jsonParseError) {
      // returning as plain text if it's not valid JSON
      return decryptedData;
    }
  } catch (error) {
    console.error("Error decrypting query:", error.message);
    return null;
  }
}
export const buildClientFullAddress = (addressObj) => {
  // Check if addressObj is not an object or is an empty object, then return an empty string
  if (typeof addressObj !== 'object' || !addressObj || Object.keys(addressObj).length === 0) {
    return "";
  }
  if (!addressObj) return "";
  let address = '';
  if (addressObj?.addressLine1) {
    address = (`${addressObj?.addressLine1}${addressObj?.addressLine2 ? (", " + addressObj?.addressLine2) : ''}`)?.trim() || '';
  } else if (addressObj?.streetNumber && addressObj?.streetName) {
    address = `${addressObj.streetNumber || ""}${addressObj.dirPrefix ? ` ${addressObj.dirPrefix}` : ""}${addressObj.streetName ? ` ${addressObj.streetName}` : ""}${addressObj.streetSuffix ? ` ${addressObj.streetSuffix}` : ""}${addressObj.dirSuffix ? ` ${addressObj.dirSuffix}` : ""}${addressObj.unit ? `, ${addressObj.unit}` : ""}`;
    // address = (`${addressObj.streetNumber || ''} ${addressObj.unit ? ((addressObj.streetName || '') + ", Unit:" + addressObj.unit + ",") : (addressObj.streetName || '')}`)?.trim() || '';
  }
  address = address + (`, ${addressObj.city || ''}, ${addressObj.state || ''} ${addressObj.zipCode || ''}`)?.trim();
  return address?.trim();
};

export const removeUnderscore = (word) => {
  if (typeof word !== 'string') return word; // Ensure input is a string
  return word.replace(/_/g, ' '); // Replace all underscores with spaces
};

export const arrangeClientDataInTD = (clientArray, role, td) => {
  clientArray?.forEach((client) => {
    if (client?.isCorp && client?.signers?.length) {
      client.signers.forEach((signer) => {
        td = {
          ...td,
          [`${signer?.personId?._id || signer?.key}_${role}FullName`]: `${signer?.fullName || signer?.personId?.fullName || ''} [${client?.fullName || ''}]`,
          [`${signer?.personId?._id || signer?.key}_${role}PhoneNumber`]: `${signer?.personId?.phoneNumber ? formatPhoneNumber(signer?.personId?.phoneNumber) : ''}`,
          [`${signer?.personId?._id || signer?.key}_${role}OfficePhoneNo`]: `${signer?.personId?.officePhoneNumber?.phoneNumber ? formatPhoneNumber(signer?.personId?.officePhoneNumber?.phoneNumber) : ''}`,
          [`${signer?.personId?._id || signer?.key}_${role}CellPhoneNo`]: `${signer?.personId?.mobilePhoneNumber?.phoneNumber ? formatPhoneNumber(signer?.personId?.mobilePhoneNumber?.phoneNumber) : ''}`,
          [`${signer?.personId?._id || signer?.key}_${role}Email`]: `${signer?.personId?.email || ''}`,
          [`${signer?.personId?._id || signer?.key}_${role}SSN`]: `${signer?.personId?.SSN || ''}`,
          ...(role === 'Seller' && {
            [`${signer?.personId?._id || signer?.key}_${role}FaxNo`]: `${signer?.personId?.fax ? formatPhoneNumber(signer?.personId?.fax) : ''}`,
          }),
        };
      });
    } else {
      td = {
        ...td,
        [`${client?.personId?._id || client?.key}_${role}FullName`]: `${client?.personId?.fullName || client?.fullName || ''}`,
        [`${client?.personId?._id || client?.key}_${role}PhoneNumber`]: `${client?.personId?.phoneNumber ? formatPhoneNumber(client?.personId?.phoneNumber) : ''}`,
        [`${client?.personId?._id || client?.key}_${role}OfficePhoneNo`]: `${client?.personId?.officePhoneNumber?.phoneNumber ? formatPhoneNumber(client?.personId?.officePhoneNumber?.phoneNumber) : ''}`,
        [`${client?.personId?._id || client?.key}_${role}CellPhoneNo`]: `${client?.personId?.mobilePhoneNumber?.phoneNumber ? formatPhoneNumber(client?.personId?.mobilePhoneNumber?.phoneNumber) : ''}`,
        [`${client?.personId?._id || client?.key}_${role}Email`]: `${client?.personId?.email || ''}`,
        [`${client?.personId?._id || client?.key}_${role}SSN`]: `${client?.personId?.SSN || ''}`,
        ...(role === 'Seller' && {
          [`${client?.personId?._id || client?.key}_${role}FaxNo`]: `${client?.personId?.fax ? formatPhoneNumber(client?.personId?.fax) : ''}`,
        }),
      };
    }
  });
  return td;
};

export const getOfferIdFromUrl = () => {
  try {
    const url = new URL(window.location.href);
    const pathParts = url.pathname.split("/");
    let offerId = pathParts.pop();
    return offerId ? offerId.replaceAll("-", "") : "";
  } catch (error) {
    return "";
  }
};
export const getOmdUrlId = () => {
  try {
    const pathSegments = window.location.pathname.split('/');
    const offerIndex = pathSegments.indexOf('offer');
    
    if (offerIndex !== -1 && pathSegments[offerIndex + 1]) {
      return pathSegments[offerIndex + 1]; 
    }
    return null; 
  } catch (error) {
    console.error("Error extracting omdUrlId:", error);
    return null;
  }
};

export const getPrimaryClientId = (clientIds = []) => {
  if (!Array.isArray(clientIds) || clientIds.length === 0) return null;
  const clientObj = clientIds[0];
  if (!clientObj) return null;
  const { personId, isCorp, signers } = clientObj;
  if (isCorp && Array.isArray(signers) && signers.length > 0) {
    const signerObj = signers[0];
    return signerObj && signerObj.personId ? signerObj.personId : null;
  } else {
    return personId || null;
  }
};

export const formatAddress = (addressObj, condition) => {
 
  if (!addressObj) {
    return "";
  }
  let addressPart1 = "";
  if (addressObj.streetNumber) {
    addressPart1 += addressObj.streetNumber;
  }
  if (addressObj.unit && addressObj.streetName) {
    addressPart1 += ` ${addressObj.streetName}, ${addressObj.unit}`;
  } else if (addressObj.streetName) {
    addressPart1 += ` ${addressObj.streetName}`;
  }
  if (condition === "PART1") {
    return addressPart1.trim();
  }

  let addressPart2 = "";
  if (addressObj.city) {
    addressPart2 += `${addressObj.city}, `;
  }
  if (addressObj.state) {
    addressPart2 += `${addressObj.state}`;
  }
  if (addressObj.zipCode) {
    addressPart2 += ` ${addressObj.zipCode}`;
  }
  if (condition === "PART2") {
    return addressPart2.trim();
  }

  return `${addressPart1.trim()}, ${addressPart2.trim()}`;
};

export const getCombinedEmailsFromArray = (personsArray) => {
  if (!Array.isArray(personsArray)) return "";
  return personsArray
    .filter((person) => person && typeof person === "object" && person.email)
    .map((person) => person.email.trim())
    .join(", ");
};

export const getCombinedFullNameAndEmailsFromArray = (personsArray) => {
  if (!Array.isArray(personsArray)) return "";
  const listItems = personsArray
    .filter((person) => person && typeof person === "object" && (person.fullName || person.email))
    .map((person) => {
      const name = person.fullName ? person.fullName.trim() : "No Name";
      const email = person.email ? person.email.trim() : "No Email";
      // return `<li>
      //           <span style="color: black;">${name}</span>
      //           (<span style="color: blue;">${email}</span>)
      //         </li>`;
      return `<li style="padding-left: 0px;">
      <span style="color: black;">${name}</span> <span style="font-weight: bold;"> - </span> 
      <span style="color: blue;">${email}</span>
    </li>`;
    })
    .join("");
  return listItems ? `<ul style="margin: 0px;">${listItems}</ul>` : "";
};

export const validateAgentsEmails = (agentsArray) => {
  if (!Array.isArray(agentsArray)) return false;
  for (const agent of agentsArray) {
    if (!validateEmail(agent.email)) {
      const agentIdentifier = agent.email ? `: ${agent.email}` : agent.fullName ? ` for ${agent.fullName}` : " for one of the agents";
      message.error(`Invalid email found${agentIdentifier}`);
      return false;
    }
  }
  return true;
};

// CREATE SELLER EMAILS LIST
export const getEmailsList = ({ savedValue, type }) => {
  if (!savedValue) return [];
  const emails = [];
  if (type === "emailOnRootLevel") {
    savedValue.forEach((person) => {
      if (!person.isCorp && person?.email) {
        emails.push(person.email);
      } else if (person.isCorp && person?.signers?.length) {
        person.signers.forEach((signer) => {
          if (signer?.email) {
            emails.push(`${signer.email} [${person.fullName}]`);
          }
        });
      }
    });
  } else if (type === 'populatedPersonId') {
    savedValue.forEach((person) => {
      if (!person.isCorp && person?.personId?.email) {
        emails.push(person.personId.email);
      } else if (person.isCorp && person?.signers?.length) {
        person.signers.forEach((signer) => {
          if (signer?.personId?.email) {
            emails.push(`${signer.personId.email} [${person.fullName}]`);
          }
        });
      }
    });
  }
  return emails.map((email) => email.trim());
};

export const formatClientAddress = (addressObj) => {
  try {
    if (!addressObj || typeof addressObj !== 'object' || !Object.keys(addressObj)?.length) return null;
    let address = '';
    if (addressObj?.addressLine1) {
      address = (`${addressObj?.addressLine1}${addressObj?.addressLine2 ? (", "+addressObj?.addressLine2) : ''}`)?.trim() || '';
    } else if (addressObj?.streetNumber && addressObj?.streetName) {
      address = (`${addressObj.streetNumber || ''} ${addressObj.unit ? ((addressObj.streetName || '') + ", Unit:" + addressObj.unit + ",") : (addressObj.streetName || '') }`)?.trim() || '';
    }
    address = address + (`, ${addressObj.city || ''}, ${addressObj.state || ''} ${addressObj.zipCode || ''}`)?.trim();
    return address?.trim();
  } catch (error) {
    console.error("Error while generating address", error?.message);
    return null;
  }
}

export const extractUniqueClientIds = (clients = []) => {
  const personIds = new Set();
  clients.forEach(client => {
    if (!client.isCorp && client.personId) {
      if (client?.personId?._id) { // if personId is an object
        personIds.add(client.personId._id);
      } else if (client?.personId) { // if personId is a string
        personIds.add(client.personId);
      }
    } else if (client.isCorp && Array.isArray(client.signers)) {
      client.signers.forEach(signer => {
        if (signer?.personId?._id) { // if personId is an object
          personIds.add(signer.personId._id);
        } else if (signer?.personId) { // if personId is a string
          personIds.add(signer.personId);
        }
      });
    }
  });
  return [...personIds];
};


export const updateClientDetails = (clientDetailsMap = {}, clients = []) => {
  return clients.map(client => {
    if (client.isCorp) {
      const updatedSigners = client.signers.map(signer => {
        const foundClient = clientDetailsMap[signer.personId];
        return {
          ...signer,
          email: foundClient?.email,
          faxNumber: formatPhoneNumber(foundClient?.faxNumber),
          address: formatClientAddress(foundClient?.addressObj),
          phoneNumber: formatPhoneNumber(foundClient?.mobilePhoneNumber?.phoneNumber)
        };
      });
      return { ...client, signers: updatedSigners };
    } else {
      const foundClient = clientDetailsMap[client.personId];
      return {
        ...client,
        email: foundClient?.email,
        faxNumber: formatPhoneNumber(foundClient?.faxNumber),
        address: formatClientAddress(foundClient?.addressObj),
        phoneNumber: formatPhoneNumber(foundClient?.mobilePhoneNumber?.phoneNumber)
      };
    }
  });
};

export const formatAgentDetails = (agent={}) => ({
  fullName: agent.fullName,
  email: agent.email,
  resureFirmId: String(agent.brokerageData?.resureFirmId || ''),
  firmName: agent.brokerageData?.name || '',
  firmLicense: agent.brokerageData?.licenseNumber || '',
  license: agent.licenseId || '',
  address: agent.brokerageData?.address || '',
  phoneNumber: agent.mobilePhoneNumber?.phoneNumber || '',
  faxNumber: agent.brokerageData?.faxNumber || '',
  personId: String(agent._id || null),
});

export const formatAllSelerAgentsDetailsFun = ({ offerSellerAgentIds = [] } = {}) => {
  let sellerAgentIdsArray = [];
  let SellerAgents = [];
  
  sellerAgentIdsArray = (offerSellerAgentIds || []).map((el) => String(el._id));
  SellerAgents = (offerSellerAgentIds || []).map((el) => formatAgentDetails(el));

  return {
    sellerAgentIds: sellerAgentIdsArray,
    SellerAgents: SellerAgents || [],
  };
};

export const filteredTransactionData = ({ ele, selectedData, source }) => {
  let transactionData = selectedData?.newTransactionData || selectedData?.transactionData || {};
  // if (ele.prefillValues) {
  //   let allInputsToDelete = Object.keys(ele.prefillValues);
  //   console.log("allInputsToDelete", allInputsToDelete);
  //   allInputsToDelete?.forEach((element) => {
  //     delete transactionData[element];
  //   });
  // }
  delete transactionData["strikeThroughSections"];
  delete transactionData["highlightSections"];
  if (source === "PROPERTY_DOCS") {
    delete transactionData["dateTable"];
    delete transactionData["addClauseData"];
    delete transactionData["addDocumentData"];
  }
  return selectedData;
};
export const getAttr = (event, attr) => {
  try {
    const val = event.target.getAttribute(attr);
    return !val || val === "null" || val === "undefined" ? null : val;
  } catch (error) {
    return null;
  }
};

export const formatBaseName = (doc, options = {}) => {
  try {
    if (typeof doc !== "object") return "";
    const base = doc[options?.nameKey] || doc?.documentName || doc?.fileName || "";
    const suffix = doc?.docCreatedCount > 1 ? `_${doc.docCreatedCount - 1}` : "";
    return `${base.trim()}${suffix}`;
  } catch (error) {
    return ``;
  }
};

export const formatDocName = (doc, options = {}) => {
  try {
    if (typeof doc !== "object" || doc === null) return "";

    const baseRaw =
      doc[options.nameKey] || doc.documentName || doc.fileName || "";
    const base = typeof baseRaw === "string" ? baseRaw.trim() : "";

    let baseName = "";

    if (doc.updatedName) {
      baseName = `${doc.updatedName} (${base})`;
    } else {
      const suffix = doc.docCreatedCount > 1 ? `_${doc.docCreatedCount - 1}` : "";
      baseName = `${base}${suffix}`;
    }

    if (doc.createdDateMili) {
      const formattedDate = moment(doc.createdDateMili).format("MM/DD/YYYY");
      const formattedTime = moment(doc.createdDateMili).format("hh:mm A");
      return `${baseName} ${formattedDate} at ${formattedTime}`;
    }

    return baseName;

  } catch (error) {
    console.error("formatDocName error:", error);
    return "";
  }
};
